import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

const TAB_ASIAKKAAT = 0
const TAB_TUOTTEET = 1
const TAB_TOIMITTAJAT = 2
const TAB_ALKUSALDOT = 3

@Component({
  templateUrl: './tuonnit.component.html',
  styleUrls: ['./tuonnit.component.css'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TuonnitComponent implements OnInit {

  aktiivinenTabiIndex = TAB_ASIAKKAAT

  constructor(
    private _route: ActivatedRoute,
    private _router: Router
  ) {}

  ngOnInit() {
    // Aloitustabi päätellään URL:sta, jotta vanhat suorat linkit
    // (/alkusaldo-import, /tuote-import, /asiakas-import, /toimittaja-import) avaavat oikean välilehden.
    // /tuonnit-reitillä voi optionaalisesti antaa ?tab=tuotteet|toimittajat|alkusaldot|asiakkaat.
    const url = this._router.url.split('?')[0]
    const tabParam = this._route.snapshot.queryParamMap.get('tab')

    if (tabParam === 'alkusaldot' || url.endsWith('/alkusaldo-import')) {
      this.aktiivinenTabiIndex = TAB_ALKUSALDOT
    } else if (tabParam === 'toimittajat' || url.endsWith('/toimittaja-import')) {
      this.aktiivinenTabiIndex = TAB_TOIMITTAJAT
    } else if (tabParam === 'tuotteet' || url.endsWith('/tuote-import')) {
      this.aktiivinenTabiIndex = TAB_TUOTTEET
    } else {
      this.aktiivinenTabiIndex = TAB_ASIAKKAAT
    }
  }

}
